module.exports = __webpack_public_path__ + "img/backti.e2611e82.png";